<template>
  <div v-title data-title="产品预订">
    <section class="container">
      <div class="user-info" v-if="formset.DeliveryAddress!=null" @click="todeliveryaddress()">
        <p class="name">
          {{formset.DeliveryAddress.ReceiverName}}
          <span>{{formset.DeliveryAddress.ReceiverPhone}}</span>
        </p>
        <p class="address">
          {{formset.DeliveryAddress.Province}}{{formset.DeliveryAddress.City}}{{formset.DeliveryAddress.Area}}{{formset.DeliveryAddress.Address}}
        </p>
      </div>
      <div class="delivery-list" v-if="formset.DeliveryAddress==null" @click="todeliveryaddress()">
        <img src="../../assets/img/add.png" width="20px" style="vertical-align: text-top;" /> 请添加收货信息
      </div>

      <div class="neworder-list">
        <div class="neworder-list-logo">
          <img :src="formset.SysCompany.LogoUrl" /><span>{{formset.SysCompany.ShopName}}</span>
          <div style="clear:both;"></div>
        </div>
        <div class="flex">
          <div class="pro-img">
            <a href>
              <img v-lazy="formset.ProductFirstPic" class="lazy-img-fadein" :key="formset.ProductFirstPic" />
            </a>
          </div>
          <div class="details-pro-title">
            <p class="name">{{formset.ProductName}}</p>
            <p class="info">{{formset.ComboName}}</p>
            <p class="tag">
              <span v-for="(tag,$index) in formset.comboTags" :key="$index"
                :style="$index==0?'display:none':''">{{tag}}</span>
            </p>
            <div class="pro-price">
              <span>￥{{formset.SalePrice}}</span>
              <div class="num-input">
                <button v-if="allCount<=1" class="disable">-</button>
                <button v-else @click="allCount=allCount-1 ,calculatePostFee()">-</button>
                <input readonly v-on:change="calculatePostFee()" type="number" v-model="allCount" />
                <button @click="allCount=allCount+1,calculatePostFee()">+</button>
              </div>
            </div>
          </div>
        </div>

        <div class="neworder-list-amount">
          <span class="gray">共{{allCount}}件</span>
          <span>小计</span>
          <span class="orange">￥{{allSalePrice}}</span>
          <span v-if="LoginType==4">省</span>
          <span v-if="LoginType==4" class="orange">￥{{allCommission}}</span>
        </div>
        <div class="pro-tips" v-if="formset.ProductType==-1">
          <p v-if="formset.ComboPriceType==1" class="usedate">使用日期：{{formset.StartDate|
            date('yyyy-MM-dd')}}至{{formset.EndDate| date('yyyy-MM-dd')}}</p>
          <p v-if="formset.ComboPriceType==2" class="usedate">出发日期：{{formset.StartDate| date('yyyy-MM-dd')}}
            天数：{{formset.Days}}天</p>
          <!-- <p v-if="formset.IsRefund==1" class="align-r gray">退款截止时间： {{formset.RefundDate}}</p> -->

          <div class="change">
            <div class="fl" v-if="formset.IsRefund==1">可退</div>
            <div class="fl" v-if="formset.IsRefund==0">不可退</div>
            <div class="fr">退改规则</div>
            <div class="clear"></div>
          </div>
          <div class="rule" v-if="formset.IsRefund==1">
            截止退款日期{{formset.RefundDate}}前未消费的订单可申请退款，
            需收取售价的20%手续费，逾期不可退款
          </div>
          <div class="rule" v-if="formset.IsRefund==0" v-html="formset.ChangeContent"></div>
        </div>
        <div class="pro-tips" v-else>
          <div class="change" v-on:click="refoundshowmethod()">
            <div v-bind:class="[refoundshow ? 'frdown' :'frup']">退改规则</div>
            <div class="clear"></div>
          </div>
          <div class="rule" v-if="refoundshow" v-html="formset.ChangeContent"></div>
        </div>
      </div>
      <div class="reserve-info">
        <div class="inline-input">
          <wv-input placeholder="请输入备注" label="备注：" v-model="order.Memo" :max-length="100"></wv-input>
        </div>
      </div>

      <!--付款方式-->
      <div class="payment">
        <a v-if="formset.Draws.length > 0" href="javascript:void(0)" class="block" @click="changeDrawInfo()">
          <div class="link-t">优惠</div>
          <div class="link-txt" v-if="Draw!=null">
            ￥{{ Draw.Price
            }}{{ Draw.FullPrice == 0 ? "" : "(满" + Draw.FullPrice + ")" }}
          </div>
          <div class="link-txt" v-if="Draw==null">
            不使用优惠券
          </div>
        </a>
        <a href="javascript:void(0)" class="block">
          <div class="link-t">付款方式</div>
          <div class="link-txt">微信</div>
        </a>
        <a href="javascript:void(0)" class="block">
          <div class="link-t">运费</div>
          <div v-if="!isRefusePostArea&&currentPostage==0" class="link-txt">包邮</div>
          <div v-if="isRefusePostArea" class="link-txt">当前地址不发货</div>
          <div v-if="!isRefusePostArea&&currentPostage!=0" class="link-txt">￥{{currentPostage}}</div>
        </a>
      </div>
    </section>

    <!--优惠选择-->
    <wv-popup :visible.sync="DrawInfo" style="width: 100%; padding: 20px; padding-bottom: 100px" class="pop-produce">
      <div class="pop-pro-select">
        <p>选择优惠券</p>
        <div class="select-btn">
          <button @click="onChangeDraw()">不使用</button>
          <button @click="onChangeDraw(model)" :class="model == Draw ? 'active' : ''"
            v-for="(model, $index) in formset.Draws" :key="$index">
            ￥{{ model.Price
            }}{{ model.FullPrice == 0 ? "" : "(满" + model.FullPrice + ")" }}
          </button>
        </div>
      </div>
    </wv-popup>

    <footer class="fix-b">
      <p class="tips">
        <span>提交订单成功后，请在30分钟内完成付款。</span>
      </p>
      <div class="bottom-btn">
        <p class="btn-info">
          总金额
          <span v-if="LoginType==4" class="orange">{{(currentPostage-0+allSalePrice-allCommission -
            DrawPrize)|currency('￥',2)}}</span>
          <span v-if="LoginType==5" class="orange">{{(allSalePrice-0+currentPostage -
            DrawPrize)|currency('￥',2)}}</span>
        </p>
        <button :style="!isRefusePostArea?'background: #f97334;':'background-color:#999'" class="sub"
          @click="confirm()">提交订单</button>
      </div>
    </footer>
  </div>
</template>

<script>
  import { Toast } from "we-vue";
  import thumb from "../../assets/logo.png";
  import { Dialog } from "we-vue";

  export default {
    name: "productpreorder",
    data: function () {
      return {
        LoginType: -1, //(-1=未登录/4=家游客/5=直客)
        formset: {
          SysCompany: {
            ShopName: "",
            CreateTime: "",
            ProductCount: 1
          }
        },
        deliveryAddressID: 0,
        allCount: 1,
        allSalePrice: 0,
        allCommission: 0,
        allSettlementPrice: 0,
        order: { Memo: "", ContactPhone: "" },
        getcodeshow: true,
        waitminutes: "",
        codetimer: null,
        VerificationCodePic: { OnceString: "" }, //图形验证码信息
        PicCodeValue: "", //图形验证码值
        needcheckPhone: false,
        SubmitOrderCount: 0, //提交订单次数
        refoundshow: false,
        isnotFreeArea: false,
        currentPostage: 0,
        showchoosePostage: false,
        defaultArea: {},
        specialArea: [],
        refuseArea: {},
        ProvinceCityTreeList: [],
        isRefusePostArea: false,
        IsFreeShipping: 0,
        isdisabled: true,
        DrawInfo: false,
        Draw: null,
        DrawPrize: 0,
      };
    },
    created: function () {
      debugger;
      var deliveryAddressID = localStorage.getItem("chooseaddress");
      if (
        deliveryAddressID != null &&
        deliveryAddressID != undefined &&
        deliveryAddressID.length > 0
      ) {
        this.deliveryAddressID = deliveryAddressID;
        localStorage.removeItem("chooseaddress");
      }
      this.allCount = parseInt(this.$route.query.allCount);
      this.InitProductpreorder();
      this.getpiccode();
    },

    methods: {
      todeliveryaddress: function () {
        this.$router.push({
          path: "/page/deliveryaddress",
          query: { type: "chooseaddress" }
        });
      },
      //验证
      validatesave: function () {
        var com = this.$refs;
        var flag = true;
        for (var c in com) {
          if (this.$refs[c] != undefined) {
            if (this.$refs[c].length != undefined) {
              this.$refs[c][0].validate();
              flag = this.$refs[c][0].valid;
            } else {
              this.$refs[c].validate();
              flag = this.$refs[c].valid;
            }
            if (!flag) return flag;
          }
        }
        return flag;
      },
      refoundshowmethod() {
        this.refoundshow = !this.refoundshow;
      },
      //确认下单
      confirm: function () {
        //_hmt.push(["_trackEvent", "订单", "提交", "提交订单"]);
        if (this.formset.DeliveryAddress == null) {
          Toast.fail("请选择收货地址");
          return;
        }
        if (!this.validatesave()) {
          Toast.fail("联系电话不合法");
          return;
        }
        if (this.needcheckPhone) {
          this.checkcode();
        } else {
          this.submitorder();
        }
      },
      //提交订单
      submitorder: function () {
        this.$store.commit("showLoading");
        this.SubmitOrderCount += 1;
        if (this.SubmitOrderCount > 1) {
          //只可提交一次
          return;
        }

        if (this.isRefusePostArea) {
          this.$store.commit("hideLoading");
          this.SubmitOrderCount = 0; //提交失败，提交次数置为0，可再次提交
          //Toast.fail("该地区目前尚不发货，请选择其他收货地址!");
          Dialog.alert({
            title: "提示信息",
            message: "该地区目前尚不发货，请选择其他收货地址!"
          }).then(() => {
            this.$router.push({
              path: "/page/deliveryaddress",
              query: {
                type: "chooseaddress"
              }
            });
          });
          return;
        }

        var data = this.order;
        data["AllCount"] = this.allCount;
        data["ComboPriceGuid"] = this.formset.ComboPriceGuid;
        var disid = this.$route.query.disid;
        if (disid != undefined && disid != null && disid.length > 0) {
          data["DisSysUserGuid"] = disid;
        }
        var stype = this.$route.query.stype;
        if (stype != undefined && stype != null && stype.length > 0) {
          data["IsPlatOrder"] = true;
        } else {
          data["IsPlatOrder"] = false;
        }
        //2019/12/16 收货地址id赋值disid无关
        data["DeliveryAddressID"] = this.deliveryAddressID;
        data["currentPostage"] = this.currentPostage;

        //增加可以不使用优惠券的逻辑-待测试
        if (this.formset.Draws.length > 0 && this.Draw != null) {
          data["TbDrawWinRecord"] = this.Draw.TbDrawWinRecord;
          data["FullPrice"] = this.Draw.FullPrice;
          data["Price"] = this.Draw.Price;
        } else {
          data["TbDrawWinRecord"] = 0;
          data["FullPrice"] = 0;
          data["Price"] = 0;
        }

        this.$http
          .post(this.GLOBAL.BASE_URL + "api/tborder/submitorder", data, {
            emulateJSON: true
          })
          .then(function (d) {
            var rep = JSON.parse(d.bodyText);
            if (rep.Success) {
              this.$router.push({
                path: "/page/orderdetail",
                query: {
                  OrderGuid: rep.Data,
                  type: "pay"
                }
              });
            } else {
              this.SubmitOrderCount = 0; //提交失败，提交次数置为0，可再次提交
              Toast.fail(rep.Message);
            }
            this.$store.commit("hideLoading");
          });
      },
      //获取图形验证码
      getpiccode: function () {
        this.$http
          .get(this.GLOBAL.BASE_URL + "api/login/getverificationcodepic", {
            params: { codeGuid: this.VerificationCodePic.OnceString }
          })
          .then(
            function (d) {
              var rep = JSON.parse(d.bodyText);
              if (rep.Success) {
                this.VerificationCodePic = rep.Data;
              } else {
                Toast.fail(rep.Message);
              }
            },
            function (d) {
              console.log(d);
            }
          );
      },
      //验证验证码
      checkcode: function () {
        if (this.order.ContactPhone == "") {
          Toast.fail("手机号不能为空");
          return;
        }
        if (
          this.PicCodeValue == undefined ||
          this.PicCodeValue == null ||
          this.PicCodeValue == ""
        ) {
          Toast.fail("图形验证码不能为空");
          return;
        }

        if (
          this.order.Password == undefined ||
          this.order.Password == null ||
          this.order.Password == ""
        ) {
          Toast.fail("点击获取验证码填写短信码");
          return;
        }
        this.$http
          .get(this.GLOBAL.BASE_URL + "api/login/checkverificationcode", {
            params: {
              telephone: this.order.ContactPhone,
              code: this.order.Password,
              loginType: 5
            }
          })
          .then(
            function (d) {
              var rep = JSON.parse(d.bodyText);
              if (rep.Success) {
                this.LoginType = 5;
                this.submitorder();
              } else {
                this.getpiccode();
                Toast.fail(rep.Message);
              }
            },
            function (d) {
              console.log(d);
            }
          );
      },
      changeDrawInfo: function () {
        this.DrawInfo = true;
      },
      onChangeDraw: function (value) {
        this.Draw = value;
        //支持不使用优惠券-待测试，value空时不使用
        if (this.LoginType == 4) {
          if (this.Draw == null || this.allSalePrice - this.allCommission < this.Draw.FullPrice) {
            this.DrawPrize = 0;
          } else {
            if (this.allSalePrice - this.allCommission > this.Draw.Price) {
              this.DrawPrize = this.Draw.Price;
            } else {
              this.DrawPrize = this.allSalePrice - this.allCommission - 0.01;
            }
          }
        }
        if (this.LoginType == 5) {
          if (this.Draw == null || this.allSalePrice < this.Draw.FullPrice) {
            this.DrawPrize = 0;
          } else {
            if (this.allSalePrice - this.allCommission > this.Draw.Price) {
              this.DrawPrize = this.Draw.Price;
            } else {
              this.DrawPrize = this.allSalePrice - this.allCommission - 0.01;
            }
          }
        }
        this.DrawInfo = false;
      },
      //获取验证码
      getcode: function () {
        if (this.order.ContactPhone == "") {
          Toast.fail("手机号不能为空");
          return;
        }
        if (this.PicCodeValue == "") {
          Toast.fail("图形验证码不能为空");
          return;
        }
        const TIME_COUNT = 60;
        if (!this.codetimer) {
          this.waitminutes = TIME_COUNT;
          this.getcodeshow = false;
          this.codetimer = setInterval(() => {
            if (this.waitminutes > 0 && this.waitminutes <= TIME_COUNT) {
              this.waitminutes--;
            } else {
              this.getcodeshow = true;
              clearInterval(this.codetimer);
              this.codetimer = null;
            }
          }, 1000);
        }
        this.$http
          .get(this.GLOBAL.BASE_URL + "api/login/getverificationcode", {
            params: {
              picCode: this.PicCodeValue,
              onceString: this.VerificationCodePic.OnceString,
              telephone: this.order.ContactPhone,
              loginType: 5
            }
          })
          .then(
            function (d) {
              var rep = JSON.parse(d.bodyText);
              if (rep.Success) {
              } else {
                this.waitminutes = 0;
                this.getpiccode();
                Toast.fail(rep.Message);
              }
            },
            function (d) {
              console.log(d);
            }
          );
      },
      choosePostage: function (amount) {
        if (this.isnotFreeArea) {
          this.currentPostage =
            this.formset.ComboFreightTemplate.Postage + amount;
        } else {
          this.currentPostage = amount;
        }

        this.showchoosePostage = false;
      },
      showPostage: function () {
        this.showchoosePostage = true;
      },

      calculatePostFee: function () {
        debugger;
        var goodAmount = this.allCount;
        var postPrice = 0;
        if (this.IsFreeShipping == 0) {
          var provinceName = this.formset.DeliveryAddress.Province;
          var cityName = this.formset.DeliveryAddress.City;
          //查出地址中城市的代号
          var cityCode = this.matchProvinceAndCity(provinceName, cityName);
          //先看是否是不发货地区true是不发货地区，false代表是发货地区
          var isRefuseArea = this.seacrhIsRefuseArea(cityCode);
          this.isRefusePostArea = isRefuseArea;
          //匹配是否是指定运费地区,如果是则计算价格并返回
          if (isRefuseArea) {
            this.isRefuseArea = false;
          }
          if (!isRefuseArea) {
            var objspecial = this.searchIsSpecialArea(cityCode, goodAmount);
            if (objspecial.isSpecial) {
              this.currentPostage = objspecial.postPrice;
              this.Calculaterice();
              return;
            }
          }
          //以上都不是，怎根据默认运费收取快递费
          if (!isRefuseArea) {
            postPrice = this.calculateDefaultPrice(goodAmount);
            this.currentPostage = postPrice;
            this.Calculaterice();
            return;
          }
        } else if (this.IsFreeShipping == 1) {
          this.currentPostage = 0;
          this.Calculaterice();
          return;
        }
      },

      Calculaterice: function () {
        debugger;
        (this.allSalePrice = this.allCount * this.formset.SalePrice),
          (this.allCommission = this.allCount * this.formset.Commission),
          (this.allSettlementPrice = (
            this.allCount * this.formset.SettlementPrice
          ).toFixed(2));
        var p1 = this.currentPostage - 0 + this.allSalePrice - this.allCommission;
        var p2 = this.allSalePrice - 0 + this.currentPostage;
        
        if (this.formset.Draws.length > 0 && this.Draw != null) {
          this.onChangeDraw(this.Draw);
        }
      },

      calculateDefaultPrice: function (goodAmount) {
        var postPrice = 0;
        var thisfamount = parseInt(this.defaultArea.mamount);
        var thisfprice = parseInt(this.defaultArea.mprice).toFixed(2);
        var thisoamount = parseInt(this.defaultArea.addamount);
        var thisoprice = parseInt(this.defaultArea.addprice).toFixed(2);
        if (goodAmount <= thisfamount) {
          postPrice = parseInt(thisfprice);
        } else {
          var maincount = parseInt((goodAmount - thisfamount) / thisoamount); //超出首件的数量的整数倍数
          var partcount = (goodAmount - thisfamount) % thisoamount; //超出首件的数量的整数余数
          postPrice = parseInt(maincount * thisoprice) + parseInt(thisfprice);
          if (partcount != 0) {
            postPrice += parseInt(thisoprice);
          }
        }
        return postPrice;
      },

      //匹配是否是指定运费地区,如果是则计算价格并返回
      searchIsSpecialArea: function (cityCode, goodAmount) {
        var postPrice = 0;
        var isSpecial = false;
        var specialAreaMeaagageList = this.specialArea;
        for (var i = 0; i < specialAreaMeaagageList.length; i++) {
          var thisspecialAreaCodeStr = specialAreaMeaagageList[i].areaId;
          var thisfamount = parseInt(specialAreaMeaagageList[i].famount);
          var thisfprice = parseInt(specialAreaMeaagageList[i].fprice);
          var thisoamount = parseInt(specialAreaMeaagageList[i].oamount);
          var thisoprice = parseInt(specialAreaMeaagageList[i].oprice);
          if (thisspecialAreaCodeStr.indexOf(",") > 0) {
            var thisspecialAreaCodeList = thisspecialAreaCodeStr.split(",");
            if (thisspecialAreaCodeList.indexOf(cityCode) != -1) {
              isSpecial = true;
              if (goodAmount <= thisfamount) {
                postPrice = thisfprice;
              } else {
                var maincount = parseInt(
                  (goodAmount - thisfamount) / thisoamount
                ); //超出首件的数量的整数倍数
                var partcount = (goodAmount - thisfamount) % thisoamount; //超出首件的数量的整数余数
                postPrice =
                  parseInt(maincount * thisoprice) + parseInt(thisfprice);

                if (partcount != 0) {
                  postPrice += parseInt(thisoprice);
                }
              }
            }
          } else {
            if (thisspecialAreaCodeStr == cityCode) {
              isSpecial = true;
              if (goodAmount <= thisfamount) {
                postPrice = thisfprice;
              } else {
                var maincount = parseInt(
                  (goodAmount - thisfamount) / thisoamount
                ); //超出首件的数量的整数倍数
                var partcount = (goodAmount - thisfamount) % thisoamount; //超出首件的数量的整数余数
                postPrice =
                  parseInt(maincount * thisoprice) + parseInt(thisfprice);

                if (partcount != 0) {
                  postPrice += parseInt(thisoprice);
                }
              }
            }
          }
        }
        var objspecial = {};
        objspecial.postPrice = postPrice;
        objspecial.isSpecial = isSpecial;
        return objspecial;
      },

      //查询是否是不发货地区
      seacrhIsRefuseArea: function (cityCode) {
        var isRefuseArea = true;
        var dCityCodeStr = this.refuseArea.noareaId;
        if (
          dCityCodeStr != null &&
          dCityCodeStr != undefined &&
          dCityCodeStr != ""
        ) {
          if (dCityCodeStr.indexOf(",") > 0) {
            var dCityCodeList = dCityCodeStr.split(",");
            if (dCityCodeList.indexOf(cityCode) == -1) {
              isRefuseArea = false;
            }
          } else {
            if (dCityCodeStr != cityCode) {
              isRefuseArea = false;
            }
          }
        } else {
          isRefuseArea = false;
        }
        return isRefuseArea;
      },
      //根据省份名字和城市名获得城市Code
      matchProvinceAndCity: function (provinceName, cityName) {
        var cityCode = "";
        for (var i = 0; i < this.ProvinceCityTreeList.length; i++) {
          if (this.ProvinceCityTreeList[i].Name == provinceName) {
            var innerCityList = this.ProvinceCityTreeList[i].Children;
            for (var j = 0; j < innerCityList.length; j++) {
              if (innerCityList[j].Name == cityName) {
                cityCode = innerCityList[j].ID;
                break;
              }
            }
            break;
          }
        }
        return cityCode;
      },
      InitProductpreorder: function () {
        this.$http
          .get(this.GLOBAL.BASE_URL + "api/tbproduct/getproductpreorder", {
            params: {
              type: this.$route.query.type,
              typeofguid: this.$route.query.typeofguid,
              deliveryAddressID: this.deliveryAddressID
            }
          })
          .then(function (d) {
            debugger;
            var rep = JSON.parse(d.bodyText);
            if (rep.Success) {
              this.formset = rep.Data;
              if (this.formset.ProductName.length >= 27) {
                this.formset.ProductName =
                  this.formset.ProductName.substring(0, 27) + "...";
              }
              if (
                this.formset.DeliveryAddress != null &&
                this.formset.DeliveryAddress != undefined
              ) {
                this.deliveryAddressID = this.formset.DeliveryAddress.ID;
              } else {
                Dialog.alert({
                  title: "提示信息",
                  message: "您还没有收货地址，请先录入收货地址"
                }).then(() => {
                  this.$router.push({
                    path: "/page/deliveryaddressadd",
                    query: {
                      //type: "chooseaddress"
                    }
                  });
                });
              }
              this.LoginType = this.formset.LoginType;
              this.order.ContactName = this.formset.ContactName;
              this.order.ContactPhone = this.formset.ContactPhone;
              this.allSalePrice = this.formset.SalePrice;
              this.allCommission = this.formset.Commission;

              this.order.ContactName = this.formset.DeliveryAddress.ReceiverName;
              this.order.ContactPhone = this.formset.DeliveryAddress.ReceiverPhone;

              if (
                this.order.ContactPhone == undefined ||
                this.order.ContactPhone == null ||
                this.order.ContactPhone == ""
              ) {
                this.needcheckPhone = true;
              }
              this.defaultArea = JSON.parse(
                this.formset.NewFreightTemplate.DefaultFreight
              );
              this.specialArea = JSON.parse(
                this.formset.NewFreightTemplate.DeliveryFreight
              );
              this.refuseArea = JSON.parse(
                this.formset.NewFreightTemplate.NotDeliveryArea
              );
              //省份城市tree
              this.ProvinceCityTreeList = this.formset.ProvinceCityTreeList;
              this.IsFreeShipping = this.formset.NewFreightTemplate.IsFreeShipping;
              this.calculatePostFee(this.allCount);
            } else {
              Toast.fail(rep.Message);
            }
          });
      }
    }
  };
</script>

<style>
  .inline-input div.weui-cell {
    padding: 10px 5px;
  }

  .waring-msg {
    position: fixed;
    bottom: 50px;
    width: 100%;
    line-height: 40px;
    text-align: center;
    background: #efeff4;
    font-size: 0.9em;
  }

  .order-price {
    width: 50%;
    height: 50px;
    line-height: 50px;
    text-align: center;
    background-color: #efeff4;
    color: #ff7125;
  }

  .sumitorder {
    width: 50%;
    height: 50px;
    line-height: 50px;
    text-align: center;
    color: #efeff4;
    font-weight: bolder;
    background-color: #ff7125;
    /* background-image: -webkit-linear-gradient(left, #FF4500, #f4802a);
  background-image: -moz- oldlinear-gradient(left, #FF4500, #f4802a);
  background-image: linear-gradient(to right, #FF4500, #f4802a); */
  }
</style>


// WEBPACK FOOTER //
// src/components/combo/productpreorder.vue